import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import _defineProperty from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/web.dom.iterable";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { queryUserTreeList } from '@/api/api';
import { getAction } from '@/api/manage';
export default {
  props: {
    flowSrc: {
      type: String,
      default: 'om_process_currency'
    }
  },
  data: function data() {
    return {
      userInfo: this.$store.getters.userInfo,
      workFlowItemList: [],
      selectIndex: 0,
      visible: false,
      treeData: [],
      treeData1: [],
      checkedKeys: [],
      selectedNode: [],
      searchValue: '',
      iExpandedKeys: []
    };
  },
  mounted: function mounted() {
    this.getFlowUser();
  },
  methods: {
    getFlowUser: function getFlowUser() {
      var _this = this;

      getAction('/sys/work/flow/getAllWorkFlow', {
        userId: this.userInfo.id
      }).then(function (res) {
        if (res.success) {
          _this.workFlowItemList = res.result.workFlowItemList;
          _this.workFlowItemList[0].approvalUser = [{
            realname: _this.userInfo.realname,
            id: _this.userInfo.id
          }];
        }
      });
    },
    getUserTree: function getUserTree() {
      var _this2 = this;

      var that = this;
      that.treeData = []; // 用户

      queryUserTreeList().then(function (res) {
        if (res.success) {
          _this2.iExpandedKeys = [];

          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];
            that.treeData.push(temp);
            that.treeData1.push(temp);

            _this2.iExpandedKeys.push(temp.key);
          }

          that.checkedKeys = that.workFlowItemList[that.selectIndex].approvalUser.map(function (v) {
            return v.id;
          });
          that.setDisabled(that.treeData);
        }
      });
    },
    // 设置树禁用
    setDisabled: function setDisabled(treeData) {
      var _this3 = this;

      treeData.forEach(function (item) {
        if (item.children) {
          _this3.setDisabled(item.children);
        } else {
          if (/^[A-Za-z]+$/.test(item.key[0]) && item.isLeaf) {
            item.disabled = true;
          }
        }
      });
      this.$forceUpdate();
    },
    deleteUser: function deleteUser(item, index) {
      item = item.splice(index, 1);
    },
    openPeopleTree: function openPeopleTree(index) {
      this.selectIndex = index;
      this.searchValue = '';
      this.visible = true;
      this.getUserTree();
    },
    searchTree: function searchTree(tree, keyword) {
      var includeChildren = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var newTree = [];

      for (var i = 0; i < tree.length; i++) {
        var node = tree[i];

        if (node.data.initialPyLower) {
          if (node.title.includes(keyword) || node.data.initialPyLower.includes(keyword) || node.data.initialPyUpper.includes(keyword)) {
            // 如果当前节点符合条件，则将其复制到新的树形结构中，并根据 includeChildren 参数决定是否将其所有子节点也复制到新的树形结构中
            newTree.push(_objectSpread(_objectSpread({}, node), {}, {
              children: includeChildren ? this.searchTree(node.children || [], '', true) : []
            }));
          } else if (node.children) {
            // 如果当前节点不符合条件且存在子节点，则递归遍历子节点，以继续搜索
            var result = this.searchTree(node.children, keyword, true);

            if (result.length > 0) {
              // 如果子节点中存在符合条件的节点，则将其复制到新的树形结构中
              newTree.push(_objectSpread(_objectSpread({}, node), {}, {
                children: result
              }));
            }
          }
        } else if (node.title.includes(keyword)) {
          newTree.push(_objectSpread(_objectSpread({}, node), {}, {
            children: includeChildren ? this.searchTree(node.children || [], '', true) : []
          }));
        } else if (node.children) {
          // 如果当前节点不符合条件且存在子节点，则递归遍历子节点，以继续搜索
          var _result = this.searchTree(node.children, keyword, true);

          if (_result.length > 0) {
            // 如果子节点中存在符合条件的节点，则将其复制到新的树形结构中
            newTree.push(_objectSpread(_objectSpread({}, node), {}, {
              children: _result
            }));
          }
        }
      }

      return newTree;
    },
    onChange: function onChange(e) {
      var value = e.target.value;
      Object.assign(this, {
        searchValue: value
      });
      this.treeData = this.searchTree(this.treeData1, e.target.value, true);
      this.setDisabled(this.treeData);
    },
    onCheck: function onCheck(checkedKeys, e) {
      var _this4 = this;

      this.checkedKeys = checkedKeys.filter(function (item) {
        return !/^[A-Za-z]+$/.test(item[0]);
      });
      this.selectedNode = [];
      e.checkedNodes.forEach(function (v) {
        if (!/^[A-Za-z]+$/.test(v.data.props.value[0])) {
          _this4.selectedNode.push({
            realname: v.data.props.label,
            id: v.data.props.value
          });
        }
      });
    },
    handleOk: function handleOk() {
      this.workFlowItemList[this.selectIndex].approvalUser = this.selectedNode;
      this.visible = false;
    },
    handleCancel: function handleCancel() {
      this.visible = false;
    },
    getWorkFlowItemList: function getWorkFlowItemList() {
      var workFlowItemList = [];
      this.workFlowItemList.forEach(function (item) {
        if (item.statusId != -1) {
          if (item.approvalUser[0]) {
            workFlowItemList.push({
              approvalUser: item.approvalUser.map(function (v) {
                return {
                  id: v.id
                };
              })
            });
          } else {
            workFlowItemList.push({
              approvalUser: []
            });
          }
        }
      });
      return workFlowItemList;
    }
  }
};